import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import BaseGynObsReport from "./BaseGynObsReport";

const PostNatalCareRegisterReport = ({ actions }) => (
  <BaseGynObsReport
    title="Post Natal Care Register Report"
    endpoint="obgyn/reports/postnatal-care-register"
    actions={actions}
    columns={[
      { key: "visit_date", label: "Visit Date" },
      { key: "patient_number", label: "Patient No." },
      { key: "patient_name", label: "Patient Name" },
      { key: "phone_no", label: "Phone" },
      { key: "pnc_visit_number", label: "PNC Visit No." },
      { key: "breastfeeding_status", label: "Breastfeeding" },
      { key: "fp_method_started", label: "FP Method Started" },
    ]}
  />
);

const mapDispatchToProps = (dispatch) => ({
  actions: {
    snackbarActions: bindActionCreators(snackbarActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(PostNatalCareRegisterReport);
